// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"427":"24e058fb146b2e93934a","796":"2ed6741c920dce71c3f7","872":"a1b7ead4d1a3dc0fa281"}[chunkId] + ".js";
};